<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <path fill-rule="evenodd" d="M10.647 11.703a5.25 5.25 0 1 1 1.06-1.061l4.046 4.046-1.06 1.06-4.046-4.045ZM11.25 7.5a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" clip-rule="evenodd"/>
</svg>
